import { merge } from '../helper';
import isEmptyObject from '../general/isEmpty/isEmptyObject';
import prependChild from '../general/prepend/prependChild';

import * as exElement from './element';

// ----------------------------------------------------------------------------

function create(config: Record<string, any> = {}): Record<string, any> {
    // Default Config
    const defConfig: Record<string, any> = {};

    // Merge
    merge(defConfig, config);

    // ------------------------------------------------------------------------

    //
    const elements: Record<string, any> = {};

    // Create element (header)
    const elHeader = exElement.create({
        merge: defConfig,
        class: {
            new: 'header',
        },
    });
    elements.element = elHeader;

    // ------------------------------------------------------------------------

    // Settings
    settings(elements, defConfig);

    // ------------------------------------------------------------------------

    // Return
    return elements;
}

function settings(elements: Record<string, any>, config: Record<string, any> = {}): void {
    // If using header title
    if (config.headerTitle) {
        // Create element (title)
        const elTitle = exElement.create({
            merge: config.headerTitle,
            class: {
                new: 'title',
            },
        });
        elements.element.appendChild(elTitle);
        elements.title = elTitle;
    }

    // ------------------------------------------------------------------------

    // If using tools
    if (!isEmptyObject(config.tools)) {
        elements.tools = {};

        // If using right
        if (!isEmptyObject(config.tools.right) || config.tools.right === true) {
            elements.tools.right = {};

            // Create element (tools)
            const elTools = exElement.create({
                merge: config.tools.right,
                class: {
                    new: 'tools',
                },
            });
            elements.element.appendChild(elTools);
            elements.tools.right.element = elTools;
        }

        // If using left
        if (!isEmptyObject(config.tools.left) || config.tools.left === true) {
            elements.tools.left = {};

            // Create element (tools)
            const elTools = exElement.create({
                merge: config.tools.left,
                class: {
                    new: 'tools',
                },
            });
            prependChild(elements.element, elTools);
            elements.tools.left.element = elTools;
        }
    }
}

// ----------------------------------------------------------------------------

export { create };
